module.exports = __webpack_public_path__ + "img/banner-1.a34ad07f.png";